import "./App.css";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider, } from "react-router-dom";
import Layout from "./components/layout";
import { AuthGuard } from "./components/auth/auth-guard";
import Login from "./components/auth/login";
import ForgotPassword from "./components/forgot-password/forgot-password";
import ResetPassword from "./components/forgot-password/reset-password";
import { Projects } from "./components/project/projects";
import { Redirect404 } from "./components/redirect-404";
import { ProjectDetails } from "./components/project/project-details";
import { Editor } from "./components/editor/editor";
import { LayoutProvider } from "./contexts/layout-context";
import "./yup-extensions";
import { ToastProvider } from "./contexts/toast-context";
import { Users } from "./components/user/users";
import useLocaleSaver from "./hooks/locale-saver";
import * as Sentry from "@sentry/react";
import { ProfilePage } from "./components/profile/profile-page.jsx";
import { UserDetailsPage } from "./components/user/user-details-page.jsx";
import Register from "./components/auth/register.jsx";
import { VerifyEmail } from "./components/auth/verify-email.jsx";
import { ResendEmailVerification } from "./components/auth/resend-email-verification.jsx";
import { Help } from "./components/help/help.jsx";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(
  createBrowserRouter
);

const router = sentryCreateBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <LayoutProvider>
          <ToastProvider>
            <Layout/>
          </ToastProvider>
        </LayoutProvider>
      }
    >
      <Route element={<AuthGuard invert={true}/>}>
        <Route path="login" element={<Login/>}/>
        <Route path="register" element={<Register/>}/>
        <Route path="forgot-password" element={<ForgotPassword/>}/>
        <Route path="reset-password" element={<ResetPassword/>}/>
        <Route path="verify-email" element={<VerifyEmail/>}/>
        <Route path="resend-email-verification" element={<ResendEmailVerification/>}/>
      </Route>
      <Route element={<AuthGuard/>}>
        <Route path="projects" element={<Projects/>}/>
        <Route path="help" element={<Help/>}/>
        <Route path="projects/:projectId" element={<ProjectDetails/>}/>
        <Route path="projects/:projectId/editor" element={<Editor/>}/>
        <Route path="profile" element={<ProfilePage/>}/>
        <Route path="users" element={<Users/>}/>
        <Route path="users/:userId" element={<UserDetailsPage/>}/>
      </Route>
      <Route path="p/:projectId" element={<Editor isPublic={true}/>}/>
      <Route
        path="*"
        element={
          <Redirect404
            toAuthenticated="/projects"
            toNonAuthenticated="/login"
          />
        }
      />
    </Route>
  )
);

const App = () => {
  useLocaleSaver();
  return <RouterProvider router={router}/>;
};

export default App;
